import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onUnmounted, ref, shallowRef } from 'vue'
import { Marker, MarkerOptions } from 'mapbox-gl'
import { useMapBox } from './composables/useMapBox'


export default /*#__PURE__*/_defineComponent({
  __name: 'MapBoxMarker',
  props: {
    latitude: null,
    longitude: null
  },
  setup(__props: any) {

const props = __props as {
	latitude: number
	longitude: number
};



const markerContainer = ref()

const marker = shallowRef<Marker>()

const { map } = useMapBox()

onMounted(() => {
	marker.value = new Marker({ renderless: true, element: markerContainer.value } as MarkerOptions)
		.setLngLat([props.longitude, props.latitude])
		.addTo(map!.value!)
})

onUnmounted(() => marker.value?.remove())

return { __sfc: true,props, markerContainer, marker, map }
}

})